module.exports = __webpack_public_path__ + "img/under-maintenance.f1506c29.jpg";